import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import driverAttachment from '../api/driver-attachments';

export const useGetDriverAttachment = itemRef => {
  const { entityRef } = useParams();

  return useQuery({
    queryKey: ['ticket-attachments-driver-viewable', entityRef, itemRef],
    queryFn: () => driverAttachment.getAttachment({ entityRef, itemRef }),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    enabled: !!entityRef && !!itemRef,
    refetchOnMount: 'always',
    staleTime: Infinity,
  });
};
